import { createFileRoute } from "@tanstack/react-router";
import { MultilingualServiceLanding } from "@/components/MultilingualServiceLanding";
import { KO_APOSTILLE } from "@/data/ko-service-content";
import { SEO_SITE, multiHreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const PATH = "/ko/apostille";
const C = KO_APOSTILLE;

export const Route = createFileRoute("/ko/apostille")({
  head: () => ({
    meta: [
      { title: ctaTitle("태국 아포스티유 대행 | NYC Legal 방콕 (한국어 대응)", "/ko/apostille", "th")},
      { name: "description", content: ctaDesc("방콕 아포스티유 대행: 태국 MFA 헤이그 인증 + 공증 + 인증 번역을 5~7 영업일에. 한국인 담당자가 카카오톡으로 한국어 안내. Get your timeline and checklist in minutes — chat now.", "/ko/apostille", "th")},
      { property: "og:title", content: ctaTitle("태국 아포스티유 대행 (한국어) | NYC Legal", "/ko/apostille", "th")},
      { property: "og:description", content: ctaDesc("한·태 양방향 아포스티유 원스톱. 카카오톡 한국어 견적.", "/ko/apostille", "th")},
      { property: "og:url", content: `${SEO_SITE}${PATH}` },
      { property: "og:locale", content: "ko_KR" },
    ],
    links: [
      { rel: "canonical", href: `${SEO_SITE}${PATH}` },
      ...multiHreflangLinks(
        [
          { hreflang: "th-TH", path: "/apostille" },
          { hreflang: "en", path: "/en/apostille" },
          { hreflang: "zh", path: "/zh/apostille" },
          { hreflang: "ja", path: "/ja/apostille" },
          { hreflang: "ko", path: "/ko/apostille" },
          { hreflang: "x-default", path: "/apostille" },
        ],
        "/apostille",
      ),
    ],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "LegalService",
        name: "NYC Legal — 태국 아포스티유", url: `${SEO_SITE}${PATH}`,
        areaServed: ["TH", "KR"], inLanguage: "ko",
        priceRange: "฿1,500–฿5,000", serviceType: "Apostille Service · MFA Legalisation",
        provider: { "@type": "LegalService", name: "NYC Language Institute", url: SEO_SITE },
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "FAQPage", inLanguage: "ko",
        mainEntity: C.faqs.map((f) => ({ "@type": "Question", name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a } })),
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "HowTo", inLanguage: "ko",
        name: "태국 아포스티유 절차", totalTime: "P7D",
        estimatedCost: { "@type": "MonetaryAmount", currency: "THB", value: "1500" },
        step: C.steps.map((s) => ({ "@type": "HowToStep", name: s.name, text: s.text })),
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "홈", item: `${SEO_SITE}/ko` },
          { "@type": "ListItem", position: 2, name: "아포스티유", item: `${SEO_SITE}${PATH}` },
        ],
      }) },
    ],
  }),
  component: () => <MultilingualServiceLanding c={C} />,
});
